
// DefaultRequestOptions
//export const API_BASE_URL = 'https://localhost:7298';
export const API_BASE_URL = 'https://calculadora-preco-riobrasil-api.azurewebsites.net';

export const DEFAULT_POST_REQUEST_OPTIONS = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '',
    mode: 'cors',
    redirect: 'follow',
    credentials: 'include'
  };

  export const DEFAULT_GET_REQUEST_OPTIONS = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    mode: 'cors',
    redirect: 'follow',
    credentials: 'include'
  };